import { render, staticRenderFns } from "./RegisterUnimacs.vue?vue&type=template&id=0306f6f5"
import script from "./RegisterUnimacs.vue?vue&type=script&lang=js"
export * from "./RegisterUnimacs.vue?vue&type=script&lang=js"
import style0 from "./RegisterUnimacs.vue?vue&type=style&index=0&id=0306f6f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports